import { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { exportExamResultReport, generateDropdownOptions } from '../../../utility/genricFunction'
import * as Yup from 'yup'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import { ROUTES_PATH } from '../../../utility/constants'
import { ErrorMessage, Form, Formik } from 'formik'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import Button from '../../../components/button/Button'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './examResult.scss'
import { getBatchFromBranch, getExamResultReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'


function ExamResultReport() {
    const dispatch = useDispatch()

    const reportData = useSelector((store) => store.reports.examResultReportData)
    const {loading, pageDropDownLoading} = useSelector((store) => store.reports)

    const batches = useSelector((store) => store.reports.batches)
    const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches])

    const branches = useSelector((state) => state?.branch?.branchTableData)
    const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

    const [branch, setBranch] = useState("")
    const [batch, setBatch] = useState("")
    const [isTableOpen, setIsTableOpen] = useState(false)

    const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
    const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

    const [initialValues] = useState({
        branch: userRole == "branch" ? branchId : '',
        batch: ''
    })
    const printRef = useRef()

    useEffect(() => {
        if (userRole == "branch") {
            dispatch(getBatchFromBranch(branchId))
        }
    }, [])

    const validationSchema = Yup.object().shape({
        branch: Yup.string()
            .required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
        batch: Yup.string()
            .required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    })

    function handleFormSubmit(values) {
        const data = {
            branch: values.branch,
            batch: values.batch
        }

        dispatch(getExamResultReport(data))
    }

    const breadCrumbsArr = [
        {
            title: 'Exam Result details',
            link: null,
        },
        {
            title: 'Dashboard',
            link: ROUTES_PATH.DASHBOARD,
        },
        {
            title: 'Exam result',
            link: ROUTES_PATH.EXAM_RESULT_REPORT,
        },
    ]

    const handleBranchChange = (value, setFieldValue) => {
        setFieldValue("branch", value)
        dispatch(getBatchFromBranch(value))
    }

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-center gap-2">
            <span className="text-xl text-900 font-bold">Student Details - Branch : Accquaint Batch : US-T-B06 </span>
        </div>
    );
    

    const columns = [
        {
            field: 'no',
            header: "#",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'studentCode',
            header: "Code",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'batchNo',
            header: "Batch No",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'studentName',
            header: "Student Name",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'marks',
            header: "Marks",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'resultStatus',
            header: "Result status",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
    ]

    const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <>
        {loading && <Loader loading={loading} />}
        {<Loader loading={loading} /> && <div className='examResultReport-wrapper'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    setBranch(values.branch)
                    setBatch(values.batch)

                    setIsTableOpen(true)
                    handleFormSubmit(values)
                }}
                enableReinitialize
            >
                {({ values, handleChange, handleSubmit, setFieldValue, errors }) => (
                    <Form>
                        <div className='examResultReport-header'>
                            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                        </div>

                        <div className='examResultReport'>
                            <div className='examResultReport-input-fields'>

                                <div className='examResultReport-input'>
                                    <label htmlFor=''>
                                        Branch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={branchOption}
                                        selectedValue={values.branch}
                                        className={'examResultReport-dropdown'}
                                        onChange={(e)=>handleBranchChange(e.target.value, setFieldValue)}
                                        name={'branch'}
                                        placeholder={'Select Branch'}
                                        disabled={userRole == "branch"}
                                    />
                                    <ErrorMessage name='branch' component='div' className='error-msg' />
                                </div>


                                <div className='examResultReport-input'>
                                    <label htmlFor=''>
                                        Batch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={batchOptions}
                                        selectedValue={values.batch}
                                        className={'examResultReport-dropdown'}
                                        onChange={handleChange}
                                        name={'batch'}
                                        placeholder={'Select Batch'}
                                    />
                                    <ErrorMessage name='batch' component='div' className='error-msg' />
                                </div>

                                <div className='report-submit-div'>
                                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </Form>
                )}
            </Formik>





            {isTableOpen && <div className='examResultReport-table'>
                <div className='export-option-wrapper'>
                    <div className='pdf-excel-export'>
                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={() =>
                                exportExamResultReport(reportData, columns, 'Exam Result Report', 'ExamResultReport.xlsx')
                            } // Export button
                            disabled={reportData.length > 0 ? false : true}
                        ><SimCardDownloadIcon /></Button>
                        <Button
                            text={'Export'}
                            type={'button'}
                            onClick={handleDownloadPfd}
                            disabled={reportData?.length > 0 ? false : true}
                        ><PrintIcon />
                        </Button>
                    </div>
                </div>


                <div ref={printRef} className='printable-component'>
                    <ReportDataTable
                        columns={columns}
                        // header={header} 
                        // loading={loading}
                        value={reportData}
                    />
                </div>
            </div>}
        </div>}
        </>
    )
}

export default ExamResultReport
